// extracted by mini-css-extract-plugin
module.exports = {"nineGrid_history":"History_nineGrid_history__JqcRN","luckyhistory_select_pop":"History_luckyhistory_select_pop__yebKh"};